import React, { useEffect, useState } from "react";
import "./TradeTable.scss";
import CommonTable from "../../../../components/common/CommonTable/CommonTable.jsx";
import ButtonTriangleSpinner from "../../../../components/common/ButtonTriangleSpinner/ButtonTriangleSpinner.jsx";
import { useSelector } from "react-redux";
import { ATS } from "../../../../features/ats/atsSlice";
import { CopyIcon } from "../../../../assets/Svg/SvgImages.jsx";
import { copyToClipboard, toFix } from "../../../../helpers/commonHelper";
import moment from "moment";
import { formatOrderWalletTypeLabel } from "../OrderHistory/orderHistoryMerge";
const TradeTable = ({
  trade
}) => {
  const [dataList, setDataList] = useState([]);
  const [loadMore, setIsLoadMore] = useState(false);
  const [fetchInFlight, setFetchInFlight] = useState(false);
  /** Spinner / label only while a Load More pagination request runs. */
  const [loadMoreFetching, setLoadMoreFetching] = useState(false);
  const [paginationBody, setPaginationBody] = useState({
    offset: 0,
    limit: 10,
    pairName: ''
  });
  const selectedPair = useSelector(state => state.ats.selectedPair);
  const fields = ["Tx Hash", "Symbol", "Price", "Quantity", "Wallet Type", "Settlement Scenario", "Time"];
  const formatTxId = txId => {
    if (!txId || typeof txId !== "string") return "-";
    const s = txId.trim();
    // Standard: first 5 chars + "..." + last 5 chars
    if (s.length <= 13) return s;
    return `${s.slice(0, 5)}...${s.slice(-5)}`;
  };
  const resolveTxHash = item => item?.tx_hash ?? item?.txHash ?? item?.transaction_hash ?? item?.transactionHash ?? item?.transactionHash ?? null;
  const resolveSettlementScenario = item => item?.settlement_scenario ?? item?.settlementScenario ?? item?.settlementScenarioLabel ?? item?.scenario ?? null;
  const showLoadMoreFooter = loadMoreFetching || Boolean(loadMore) && !fetchInFlight;
  const getTrades = async (body, mode = "replace") => {
    const appendPage = mode === "append";
    if (appendPage) setLoadMoreFetching(true);
    setFetchInFlight(true);
    try {
      const response = await ATS.getUserTrades(body);
      if (response.status === 200) {
        const limit = body?.limit ?? 10;
        if (response.data.length < limit) setIsLoadMore(false);else setIsLoadMore(true);
        if (appendPage) {
          setDataList(prev => [...prev, ...response.data]);
        } else {
          setDataList([...response.data]);
        }
      } else if (appendPage) {
        setIsLoadMore(false);
      }
    } finally {
      setFetchInFlight(false);
      if (appendPage) setLoadMoreFetching(false);
    }
  };
  useEffect(() => {
    if (trade) {
      setDataList(prev => [{
        price: trade.executed_price,
        quantity: trade.filled_amount,
        created_at: trade.created_at,
        wallet_type: trade.wallet_type ?? trade.walletType,
        tx_hash: trade.tx_hash ?? trade.txHash ?? trade.transaction_hash ?? trade.transactionHash ?? null,
        settlement_scenario: trade.settlement_scenario ?? trade.settlementScenario ?? trade.settlementScenarioLabel ?? trade.scenario ?? null
      }, ...prev]);
    }
  }, [trade]);
  useEffect(() => {
    if (selectedPair) {
      setIsLoadMore(true);
      paginationBody.offset = 0;
      const div = document.getElementsByClassName("tradeTable")[0]?.querySelector(".table-responsive");
      if (div && typeof div.scroll === "function") div.scroll(0, 0);
      paginationBody.pairName = selectedPair.pair_key;
      setPaginationBody(paginationBody);
      getTrades(paginationBody, "replace");
    }
  }, [selectedPair]);
  const onLoadMore = () => {
    if (fetchInFlight) return;
    paginationBody.offset += 1;
    setPaginationBody(paginationBody);
    getTrades(paginationBody, "append");
  };
  return <>
            <div className="tradeTable">
                <CommonTable fields={fields}>
                    {dataList?.map((item, index) => <tr key={index}>
                                    <td>
                                        <span className="walletTransactions__txCell">
                                            {(() => {
                const txHash = resolveTxHash(item);
                const formatted = formatTxId(txHash);
                return <>
                                                        <span title={txHash ?? ""}>
                                                            {formatted}
                                                        </span>
                                                        {txHash ? <span className="copyIcon ms-2" role="button" tabIndex={0} onClick={() => copyToClipboard(txHash)} onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      copyToClipboard(txHash);
                    }
                  }}>
                                                                <CopyIcon />
                                                            </span> : null}
                                                    </>;
              })()}
                                        </span>
                                    </td>
                                    <td>{`${selectedPair?.otherCurrency?.toUpperCase()}/${selectedPair?.baseCurrency?.toUpperCase()}`}</td>
                                    {/* <td>{selectedPair?.name?.toUpperCase()}</td> */}
                                    <td>{toFix(Number(item.price ?? item.executed_price))}</td>
                                    <td>{toFix(Number(item.quantity ?? item.filled_amount))}</td>
                                    <td>{formatOrderWalletTypeLabel(item)}</td>
                                    <td>{resolveSettlementScenario(item) ?? "--"}</td>
                                    <td>
                                        {item?.created_at ? moment(item.created_at).format("DD/MM/YYYY hh:mm A") : "--"}
                                    </td>
                                </tr>)}
                </CommonTable>
                {showLoadMoreFooter ? <div className="tableLoaderBtn">
                        <button className="btn-style black-btn tableLoaderBtn__action w-100" disabled={fetchInFlight || !loadMore} onClick={onLoadMore} type="button" aria-busy={Boolean(loadMoreFetching)}>
                            <span className="tableLoaderBtn__label">
                                {loadMoreFetching ? 'Loading' : 'Load More'}
                            </span>
                            {loadMoreFetching ? <span className="tableLoaderBtn__spinner-inline" aria-hidden="true">
                                    <ButtonTriangleSpinner size={18} />
                                </span> : null}
                        </button>
                    </div> : null}
            </div>
        </>;
};
export default TradeTable;